module.exports = __webpack_public_path__ + "static/media/video-store-in-store.9e6975cf.mp4";